import { Box, Flex, JaneGoldLogo, Link, Typography } from '@iheartjane/reefer';
import { useState } from 'react';

import { BrandLogo } from '@jane/bloom/components/gold/brandLogo';
import type { BrandSpecialViewModel } from '@jane/bloom/viewModels/brandSpecialViewModel';

import { GoldBundleProgress } from './goldBundleProgress';

import styles from './goldInfoBox.module.css';

export const GoldInfoBox = ({
  brand,
  brandLogo,
  brandSpecial,
  description,
  isBundle,
  tagLabel,
  terms,
  title,
}: {
  brand: string;
  brandLogo: string;
  brandSpecial: BrandSpecialViewModel;
  description: string;
  isBundle: boolean;
  tagLabel: string;
  terms: string;
  title: string;
}) => {
  const [viewTerms, setViewTerms] = useState(false);

  return (
    <Flex className={styles['goldInfoBoxContainer']}>
      <Box
        border="grays-light"
        borderRadius="lg"
        className={styles['goldInfoBox']}
      >
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          mb={16}
          pt={24}
          px={24}
        >
          <BrandLogo name={brand} logo_url={brandLogo} smHeight />
          <JaneGoldLogo width={72} className={styles['janeGoldLogo']} />
        </Flex>
        <Flex flexDirection="column" mb={24} px={24}>
          <Typography color="grays-mid">{brand}</Typography>
          <Typography variant="body-semibold">{title}</Typography>
          <Typography>{description}</Typography>

          {terms && (
            <Link
              mt={16}
              color="grays-mid"
              onClick={() => {
                setViewTerms(!viewTerms);
              }}
            >
              {viewTerms
                ? 'Hide terms and conditions'
                : 'View Terms and conditions'}
            </Link>
          )}

          {viewTerms && (
            <Typography color="text-main" mt={8}>
              {terms}
            </Typography>
          )}
        </Flex>

        {isBundle && (
          <GoldBundleProgress brandSpecial={brandSpecial} tagLabel={tagLabel} />
        )}
      </Box>
    </Flex>
  );
};
